import React from 'react';
import styled from 'styled-components';

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1200;
`;

const ModalBox = styled.div`
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.15);
  width: min(400px, 96vw);
  padding: 0 0 24px 0;
  position: relative;
  display: flex;
  flex-direction: column;
`;

const CloseBtn = styled.button`
  position: absolute;
  top: 16px;
  right: 18px;
  background: none;
  border: none;
  font-size: 28px;
  color: #374151;
  cursor: pointer;
  z-index: 2;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  line-height: 1;
  font-weight: 300;
  &:hover { color: #111827; }
`;

const ImgCircle = styled.div`
  width: 90px;
  height: 90px;
  border-radius: 50%;
  background: #ffd95a;
  margin: 28px auto 14px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
`;

const Title = styled.h2`
  font-size: 16px;
  font-weight: 700;
  color: #1f2937;
  text-align: center;
  margin: 0 0 20px 0;
  line-height: 1.35;
  padding: 0 32px;
`;

const Body = styled.div`
  padding: 0 32px;
  display: flex;
  flex-direction: column;
`;

const InfoRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 14px;
  color: #1f2937;
  margin-bottom: 10px;
  line-height: 1.5;
`;

const IconWrapper = styled.div`
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 1px;
  
  svg {
    width: 100%;
    height: 100%;
    color: #374151;
    stroke-width: 2;
  }
`;

const InfoContent = styled.div`
  flex: 1;
  display: block;
`;

const Label = styled.span`
  font-weight: 600;
  color: #1f2937;
`;

const DescTitle = styled.div`
  font-size: 15px;
  font-weight: 700;
  color: #1f2937;
  margin: 14px 0 8px 0;
  padding-top: 14px;
  border-top: 1px solid #e5e7eb;
`;

const Desc = styled.div`
  font-size: 13px;
  color: #6b7280;
  line-height: 1.6;
`;

// Ícones SVG
const CalendarIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
    <line x1="16" y1="2" x2="16" y2="6"/>
    <line x1="8" y1="2" x2="8" y2="6"/>
    <line x1="3" y1="10" x2="21" y2="10"/>
  </svg>
);

const LocationIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
    <circle cx="12" cy="10" r="3"/>
  </svg>
);

const UsersIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);

const UserIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
    <circle cx="12" cy="7" r="4"/>
  </svg>
);

// --- FUNÇÃO AUXILIAR (Mesma do CardEventos) ---
const getImageUrl = (path) => {
    if (!path) return '';
    const baseUrl = process.env.REACT_APP_API_URL || '';
    const cleanBase = baseUrl.replace(/\/$/, '');
    const cleanPath = path.replace(/^\//, '');
    return `${cleanBase}/${cleanPath}`;
};

const parseLocalEventDate = (dateInput) => {
  if (!dateInput) return null;
  const datePart = String(dateInput).substring(0, 10);
  const [year, month, day] = datePart.split('-').map(Number);
  if (!year || !month || !day) return null;
  return new Date(year, month - 1, day);
};

const ModalDetalhesEvento = ({ isOpen, onClose, evento }) => {
  if (!isOpen || !evento) return null;
  
  return (
    <Overlay onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <ModalBox onClick={e => e.stopPropagation()}>
        <CloseBtn onClick={onClose}>×</CloseBtn>
        
        <ImgCircle>
          {evento.imagemUrl ? (
            <img 
              src={getImageUrl(evento.imagemUrl)}//ALTERADO
              alt="logo" 
              crossOrigin="anonymous"//ADICIONADO
              style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} 
              onError={(e) => { e.target.style.display = 'none'; e.target.parentElement.innerHTML = '<span style="font-weight: 700; font-size: 11px; color: #8b6914; letter-spacing: 0.5px;">IMG</span>'; }}
            />
          ) : (
            <span style={{ fontWeight: '700', fontSize: 11, color: '#8b6914', letterSpacing: '0.5px' }}>IMG</span>
          )}
        </ImgCircle>
        
        <Body>
          <Title>{evento.nome || evento.titulo || 'Sem título'}</Title>
          
          <InfoRow>
            <IconWrapper><CalendarIcon /></IconWrapper>
            <InfoContent>
              {evento.data && (parseLocalEventDate(evento.data) || new Date(evento.data)).toLocaleDateString('pt-BR', { 
                day: '2-digit', 
                month: 'long', 
                year: 'numeric' 
              }).replace(' de ', ' de ')}
            </InfoContent>
          </InfoRow>
          
          <InfoRow>
            <IconWrapper><LocationIcon /></IconWrapper>
            <InfoContent>
              {(() => {
                const localRaw = evento.local || 'Local não informado';
                const partes = localRaw.split('|');
                const nomeLocal = partes[0].trim();
                const link = partes.length > 1 ? partes[1].trim() : null;

                if (link && link.startsWith('http')) {
                  return (
                    <a href={link} target="_blank" rel="noopener noreferrer" style={{ color: '#008080', textDecoration: 'underline', fontWeight: 'bold' }}>
                      {nomeLocal}
                    </a>
                  );
                }
                return nomeLocal;
              })()}
            </InfoContent>
          </InfoRow>
          
          <InfoRow>
            <IconWrapper><UsersIcon /></IconWrapper>
            <InfoContent>
              <Label>Vagas disponíveis:</Label> {evento.vagas || 0}
            </InfoContent>
          </InfoRow>
          
          <InfoRow>
            <IconWrapper><UserIcon /></IconWrapper>
            <InfoContent>
              <Label>Coordenador:</Label> {
                evento.coordenadorNome || 
                (typeof evento.coordenador === 'string' ? evento.coordenador : 
                (evento.coordenador?.nome || 'Coordenação'))
              }
            </InfoContent>
          </InfoRow>
          
          <DescTitle>Descrição do Evento</DescTitle>
          <Desc>{evento.descricao || 'Sem descrição.'}</Desc>
        </Body>
      </ModalBox>
    </Overlay>
  );
};

export default ModalDetalhesEvento;
